
import {
  convertObjectToArray,
  orientation,
  getFillSize,
} from './../helpers';
import { fillObject } from './../helpers/canvas';

export function getPagesByType(pages, type) {
  return Object.values(pages).find(page => page[type]);
}

export function getReorderedDroppedImages(allImages, droppedImages, layout) {
  const copiedDroppedImages = Object.assign({}, droppedImages);
  const copiedAllImages = Object.assign({}, allImages);
  const droppedImagesWithOrientations = {};

  Object.values(copiedDroppedImages).forEach((droppedImageData, index) => {
    droppedImagesWithOrientations[index] = {
      imageId: droppedImageData.imageId,
      id: droppedImageData.id,
      orientation: copiedAllImages[droppedImageData.imageId].orientation,
      order: droppedImageData.order,
    };
  });

  const newImages = {};

  layout.orientations.forEach((orientation) => {
    Object.values(droppedImagesWithOrientations).forEach((data, index) => {
      data.order = index;
      newImages[data.id] = data;
    });
  });

  return newImages;
}

export function getMoveXMoveY(filledImageSize, placeholdersSize, imageRatio) {
  let moveX = 0;
  let moveY = 0;


  const {
    width: imageWidth,
    height: imageHeight,
  } = filledImageSize;

  const {
    width: placeholderWidth,
    height: placeholderHeight,
  } = placeholdersSize;

  const imageOrientation = orientation(imageWidth, imageHeight);
  const placeholderOrientation = orientation(placeholderWidth, placeholderHeight);

  if (imageOrientation === placeholderOrientation && imageOrientation === 'portrait') {
    if (imageWidth > placeholderWidth) {
      moveX = ((imageWidth - placeholderWidth) / -2);
    }
    if (imageHeight > placeholderHeight) {
      moveY = ((imageHeight - placeholderHeight) / -2);
    }
    return {
      moveX,
      moveY,
    };
  }

  if (imageOrientation === placeholderOrientation && imageOrientation === 'landscape') {
    if (imageHeight > placeholderHeight) {
      moveY = ((imageHeight - placeholderHeight) / -2);
    }
    if (imageWidth > placeholderWidth) {
      moveX = ((imageWidth - placeholderWidth) / -2);
    }

    return {
      moveX,
      moveY,
    };
  }

  if (imageOrientation === 'portrait' && placeholderOrientation === 'landscape') {
    if (imageHeight > placeholderHeight) {
      moveY = ((imageHeight - placeholderHeight) / -2);
    }
  }

  if (imageOrientation === 'portrait' && placeholderOrientation === 'square') {
    if (imageHeight > placeholderHeight) {
      moveY = ((imageHeight - placeholderHeight) / -2);
    }
  }

  if (imageOrientation === 'landscape' && placeholderOrientation === 'portrait') {
    if (imageWidth > placeholderWidth) {
      moveX = ((imageWidth - placeholderWidth) / -2);
    }
  }

  if (imageOrientation === 'landscape' && placeholderOrientation === 'square') {
    if (imageWidth > placeholderWidth) {
      moveX = ((imageWidth - placeholderWidth) / -2);
    }
  }

  return {
    moveX,
    moveY,
  };
}


export function getPlaceholders(page, placeholders, pages, images) {
  const placeholderIds = page.placeholders;

  if (!placeholderIds || !placeholders || !pages.byId) {
    return false;
  }

  const orderedPlaceholder = convertObjectToArray(convertObjectToArray(placeholderIds).reduce((textureObjects, placeholderId) => {
    const texture = placeholders.byId[placeholderId.placeholderId];
    if (texture && pages.byId[page.id]) {
      if (pages.byId[page.id].droppedImages[texture.image] !== undefined) {
        texture.imageObject = images[pages.byId[page.id].droppedImages[texture.image].imageId];
      }
      return Object.assign({}, textureObjects, {
        [placeholderId.placeholderId]: texture,
      });
    }
    return textureObjects;
  }, {}));

  return orderedPlaceholder;
}

export function getBackgroundPlaceholders(page, backgroundPlaceholders, pages) {
  const placeholderIds = page.backgroundPlaceholders;

  if (!placeholderIds || !backgroundPlaceholders || !pages.byId) {
    return false;
  }

  const orderedPlaceholder = convertObjectToArray(convertObjectToArray(placeholderIds).reduce((textureObjects, placeholderId) => {
    const texture = backgroundPlaceholders.byId[placeholderId.backgroundPlaceholderId];

    if (texture && pages.byId[page.id]) {
      return Object.assign({}, textureObjects, {
        [placeholderId.placeholderId]: texture,
      });
    }
    return textureObjects;
  }, {}));
  return orderedPlaceholder;
}

export function getEditorPlaceholderSizes(placeholderStateById, placeholderId, bookSizes) {
  const placeholderStateByIdObject = placeholderStateById[placeholderId];
  return {
    width: placeholderStateByIdObject.width,
    height: placeholderStateByIdObject.height,
    scale: placeholderStateByIdObject.transformations.scaleX,
  };
}

export function getImageOriginalSizes(placeholderStateById, placeholderId, imagesStateById, droppedImages = null) {
  const stateImageObject = placeholderStateById[placeholderId].imageObject;
  const imageId = (stateImageObject !== undefined && Object.keys(stateImageObject).length !== 0) ? stateImageObject.id : droppedImages.id;
  const droppedImageSize = imagesStateById[imageId];
  return {
    width: droppedImageSize.originalWidth,
    height: droppedImageSize.originalHeight,
  };
}

export function setImageToCenter(placeholderStateById, placeholderId, imagesStateById, bookSizes, layout = null, coverRatio, isCover, droppedImages = null) {
  const placeholdersSize = getEditorPlaceholderSizes(placeholderStateById, placeholderId, bookSizes);
  const originalImageSize = getImageOriginalSizes(placeholderStateById, placeholderId, imagesStateById, droppedImages);
  const filledImageSize = getFillSize(placeholdersSize, originalImageSize, bookSizes, layout = null);

  const { imageRatio } = placeholderStateById[placeholderId];
  const { moveX, moveY } = getMoveXMoveY(filledImageSize, placeholdersSize, imageRatio);

  return {
    moveX,
    moveY,
  };
}

export function fillImages(placeholderId, index, droppedImages, placeholderStateById, imagesStateById, bookSizes, coverRatio, isCover) {
  const placeholdersSize = getEditorPlaceholderSizes(placeholderStateById, placeholderId, bookSizes);
  const origImageSize = getImageOriginalSizes(placeholderStateById, placeholderId, imagesStateById, droppedImages);

  const rotate = 0;
  const scale = 0;
  const filledImageSize = getFillSize(placeholdersSize, origImageSize, bookSizes);
  const { moveX, moveY } = setImageToCenter(placeholderStateById, placeholderId, imagesStateById, bookSizes, null, coverRatio, isCover, droppedImages);
  const getFillImageSizes = fillObject(
    placeholdersSize,
    origImageSize,
    moveX,
    moveY,
    rotate,
    scale,
    filledImageSize.printWidth,
    filledImageSize.printHeight,
  );
  return {
    fillsizes: getFillImageSizes,
    placeholderId,
  };
}



// WEBPACK FOOTER //
// ./src/redux/helpers/pages.js